import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import { hydrate } from "@/lib";

export interface AdapterState {
  adapter: {
    baseUrl?: string;
    nonce?: string;
  };
}

const initialState: AdapterState = {
  adapter: {}
};

export const adapterSlice = createSlice({
  name: "adapter",
  initialState,
  reducers: {
    setAdapter: (state, action) => {
      state.adapter = { ...state.adapter, ...action.payload };
    }
  },
  extraReducers: (builder) => {
    builder.addCase(hydrate, (state, action: PayloadAction<string>) => {
      return {
        ...state,
        ...action.payload[adapterSlice.name]
      };
    });
  }
});

export const { setAdapter } = adapterSlice.actions;
